module.exports = __webpack_public_path__ + "img/branch_disable.41d607a.png";